import repository from "../Repository";

export default {
  async list(screenId) {
    return await repository.post("car/car-mount-equipment-list", {
      headers: {
        s: screenId
      }
    });
  },
  async entry(screenId, payload) {
    return await repository.post("car/car-mount-equipment-entry", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
